import {mapValues} from '@shared/helpers/object'

import {getAssignmentByAPI, initDetailByAPI} from '@web/actions/detail'
import {APIStatus} from '@web/core/constants'
import {Assignment, AssignmentsByProductOrderNo, getAssignment, getProducts} from '@web/slices/productDetail/slice'
import makeSlice from '@web/slices/productDetail/sliceMaker'

const productDetailSlice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(initDetailByAPI.fulfilled, (state, {payload}) => {
                const {
                    data: {order, productOrders, productBundleGroups},
                    isMobileDisplay,
                } = payload

                const orderDateTime = new Date(order.orderDateTime).toISOString()

                state.products = getProducts(productOrders, isMobileDisplay, orderDateTime)
                state.productBundle = mapValues(
                    (group) => ({
                        ...group,
                        status: group.merchantStateType,
                        merchantTel: group.merchantTelNo,
                        isProvideTalkTalk: group.useBiztalk,
                        isConsentToTransferAbroad: false,
                        isTaxType: false,
                    }),
                    productBundleGroups,
                )
                state.giveawayProducts = order.giveawayProducts ?? undefined
            })
            .addCase(getAssignmentByAPI.pending, (state) => {
                state.assignments.reloadCount--
                state.assignments.apiStatus = APIStatus.FETCHING
            })
            .addCase(getAssignmentByAPI.fulfilled, (state, {payload}) => {
                const {data, isMobileDisplay} = payload
                state.assignments.apiStatus = APIStatus.RESOLVED
                state.assignments.value = data.reduce<AssignmentsByProductOrderNo>(
                    (acc, {productOrderNo, userActions, claims}) => {
                        if (productOrderNo) {
                            acc[productOrderNo] = {
                                main: getAssignment({userActions, isMobileDisplay}),
                                claims: claims.reduce<Record<string, Assignment[]>>((acc2, claim) => {
                                    if (claim.claimNo) {
                                        acc2[claim.claimNo] = getAssignment({
                                            userActions: claim.userActions,
                                            isMobileDisplay,
                                        })
                                    }
                                    return acc2
                                }, {}),
                            }
                        }
                        return acc
                    },
                    {},
                )
            })
            .addCase(getAssignmentByAPI.rejected, (state) => {
                state.assignments.apiStatus = APIStatus.REJECTED
            })
    },
})

export default productDetailSlice.reducer
